import { Injectable } from '@angular/core';
import { AbstractApiService } from './abstract.api.service';
import { ApiManagerService } from './api-manager.api.service';
import { IApi } from '../../model/api.interface';
import { IResponseDownload } from '../../model/response/response-download.interface';
import { GET_ANALYSIS_DATA, GET_DOWNLOAD_DATA } from '../../lib/contsants';

@Injectable({
  providedIn: 'root',
})
export class AnalysisApiService extends AbstractApiService {
  constructor(protected apiManager: ApiManagerService) {
    super(null);
  }

  protected getApi(endpoint: string): string {
    return this.apiManager.apiBuilder(endpoint);
  }

  async getAnalysis(id: string): Promise<IResponseDownload> {
    return this.get(this.getApi(`${GET_ANALYSIS_DATA}/${id}`));
  }

  async checkWhereDownloadIsAvailable(id: string) {
    const data: string[] = [];
    const apiData: Array<IApi> = this.apiManager.getAllApi();
    for (let i = 0; i < apiData.length; i++) {
      const response: any = await this.get(`${apiData[i]['api']}/v1${GET_ANALYSIS_DATA}/${id}`);
      if (response !== null) {
        data.push(apiData[i]['server']);
      }
    }
    return data;
  }

  async getDownloadContent(id: string, orderId: string, orderProductId: string): Promise<Blob> {
    const options: RequestInit = {
      headers: {},
    };
    return await this.getBlob(
      this.getApi(`${GET_DOWNLOAD_DATA}/${orderId}/${orderProductId}`),
      options,
    );
  }
}
